import React, { ReactNode, createContext, useContext } from 'react';
import { AccessTokenExtraInfo } from 'vopay';
import useStorage from '../hooks/useStorage';

type AccessTokenFields = {
  accessToken: string;
  processor: string;
  paymentMethod: string;
  extraInfo: AccessTokenExtraInfo;
  setAccessToken: (accessToken: string) => void;
  setProcessor: (processor: string) => void;
  setPaymentMethod: (paymentMethod: string) => void;
  setExtraInfo: (extraInfo: AccessTokenExtraInfo) => void;
};

export const AccessTokenFieldsContext = createContext<AccessTokenFields>({
  accessToken: '',
  processor: '',
  paymentMethod: '',
  extraInfo: {},
  setAccessToken: () => {},
  setProcessor: () => {},
  setPaymentMethod: () => {},
  setExtraInfo: () => {},
});

export const AccessTokenFieldsProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const storage = useStorage();
  const { accessToken, processor, paymentMethod, extraInfo } = storage.accessToken.getAccessTokenFields();

  const setAccessToken = (token: string) => {
    storage.accessToken.storeAccessToken(token);
  };

  const setProcessor = (processorName: string) => {
    storage.accessToken.storeProcessor(processorName);
  };

  const setPaymentMethod = (method: string) => {
    storage.paymentMethod.storePaymentMethod(method);
  };

  const setExtraInfo = (info: AccessTokenExtraInfo) => {
    storage.accessToken.storeAccessTokenExtraInfo(info);
  };

  return (
    <AccessTokenFieldsContext.Provider
      value={{
        accessToken,
        processor,
        paymentMethod,
        extraInfo,
        setAccessToken,
        setProcessor,
        setPaymentMethod,
        setExtraInfo,
      }}
    >
      {children}
    </AccessTokenFieldsContext.Provider>
  );
};

export const useAccessTokenFields = (): AccessTokenFields => useContext(AccessTokenFieldsContext);
